<template>
   <div class="landing-body">
    <LandingHeader/>
    <router-view />
    <LandingFooter/>
   </div>
</template>

<script>
  import LandingHeader from  '../components/landing/common/landingHeader';
  import LandingFooter from "../components/landing/common/LandingFooter";
  export default {
    name: "Home",
    data() {
        return {}
    },
    components: {
      LandingHeader,
      LandingFooter
    },
    methods: {},
    mounted() {
    this.$nextTick(()=> {
        document.querySelectorAll('a[href*="-anchor"]').forEach( (e) => {
          e.onclick = () => {
            let loc = window.location.pathname;
            if(loc !== "/landing/" || loc !== "/") {
              window.location.href = "/" + e.getAttribute('href');
            }
          }
        });
      });
    }
  };
</script>
<style lang="sass">
  .container
    max-width: 1440px
    width: 100%
    margin-left: auto
    margin-right: auto
    padding-left: 30px
    padding-right: 30px
  .icon-logo
    background-position: 0 0
    background-repeat: no-repeat
    width: 300px
    height: 70px
  .ico-arrow-btn
    width: 1.4em
    height: 1em
    fill: #005062
  .ico-arrow-left
    width: 0.55em
    height: 1em
    fill: #FFF
  .ico-arrow-right
    width: 0.55em
    height: 1em
    fill: #FFF
  .ico-close
    width: 0.98em
    height: 1em
    fill: #005062
  .ico-compas
    width: 0.97em
    height: 1em
    fill: #063B46
  .ico-docs
    width: 1em
    height: 1em
    fill: #005062
  .ico-eye
    width: 1.33em
    height: 1em
    fill: #FFF
  .ico-flat
    width: 4.06em
    height: 1em
    fill: #FFF
  .ico-house
    width: 1.06em
    height: 1em
    fill: #FFF
  .ico-map-white
    width: 0.7em
    height: 1em
    fill: #FFF
  .ico-menu
    width: 1.5em
    height: 1em
    fill: #005062
  .ico-play-big
    width: 1em
    height: 1em
    fill: #FFF
  .ico-play-mini
    width: 1em
    height: 1em
    fill: #FFF
  .ico-ruble
    width: 0.79em
    height: 1em
    fill: #0EB4C4
  .ico-sales
    width: 0.96em
    height: 1em
    fill: #FFF
  .ico-wave-left
    width: 2.55em
    height: 1em
    fill: #0EB4C4
  .ico-wave-right
    width: 2.55em
    height: 1em
    fill: #0EB4C4
  .icon
    display: inline-block
    font-style: normal
    content: ''
  .ico
    fill: currentColor
    transition: all 0.3s ease-in-out
  .header-landing
    background-color: #fff
    position: fixed
    top: 0
    left: 0
    width: 100%
    padding: 35px 0
    z-index: 10
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.15)
    &__phone-number
      text-align: center
      font-weight: 500
      vertical-align: middle
      .phone-icon
        font-size: 17px
        padding-right: 4px
        vertical-align: middle
        animation: call 1.8s ease-in-out infinite
        animation-delay: 2s
  .header__wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: start
    justify-content: flex-start
    -ms-flex-align: center
    align-items: center
  .header__logo
    display: inline-block
    margin-right: auto
    max-width: 250px
    img
      display: block
      height: auto
      width: 100%
      margin-bottom: 10px
    .phonenumber
      display: none
  .header__link
    position: relative
    margin-left: 24px
    font-size: 16px
    font-weight: 700
    color: #000
    transition: all 0.3s
    &:hover
      opacity: 0.7
  .header__link--login
    padding-right: 36px
    &:after
      content: ''
      position: absolute
      top: 50%
      -webkit-transform: translateY(-50%)
      transform: translateY(-50%)
      right: 0
      width: 20px
      height: 20px
      background-repeat: no-repeat
      background-size: 100%
      background-image: url(../../public/images/login.png)
  .header__menu
    padding: 0
    background-color: transparent
    border: 0
    border-radius: 0
    background-repeat: no-repeat
    background-size: 100%
    width: 20px
    height: 20px
    display: inline-block
    margin-left: 70px
    background-image: url(../../public/images/menu.png)
    transition: all 0.3s
    &.is-active
      background-image: url(../../public/images/close.svg)
    &:hover
      opacity: 0.7
      cursor: pointer
  .main-nav__mobile
    display: none
  .footer
    padding: 70px 0
  .footer__wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: justify
    justify-content: space-between
    -ms-flex-align: start
    align-items: flex-start
  .footer__col
    width: 17%
    padding-right: 15px
  .footer__contacts
    width: 32%
  .footer__title
    margin-top: 0
    margin-bottom: 32px
    font-size: 20px
    font-weight: 500
    color: #000
    opacity: 0.24
  .footer__link
    display: table
    font-size: 14px
    color: #000
    margin-bottom: 26px
    font-weight: 500
    &:hover
      text-decoration: underline
    &:last-child
      margin-bottom: 0
  .footer__logo
    margin-left: auto
    max-width: 130px
    width: 100%
    height: auto
    display: block
    margin-bottom: 48px
  .footer__form
    margin-left: auto
    max-width: 290px
    width: 100%
    position: relative
    padding-bottom: 40px
    &:after
      content: ''
      position: absolute
      bottom: 0
      left: 0
      height: 16px
      background-color: #000
      width: calc(100% + 30px)
  .footer__input
    position: relative
    input
      border: 0
      width: 100%
      display: block
      padding: 15px 24px
      font-size: 16px
      font-weight: 400
      background-color: #F2F2F2
  .footer__form-title
    margin-top: 0
    margin-bottom: 8px
    font-size: 24px
    font-weight: 700
    text-transform: uppercase
    color: #363636
  .footer__phone-block
    position: fixed
    background-color: #fff
    bottom: -10px
    left: 0
    font-size: 14px
    box-shadow: 0 0 5px -4px rgba(0,0,0,0.6)
    width: 100%
    padding: 10px 0 10px 10px
    z-index: 20
    .phone_number
      display: block
      font-size: 12px
      padding: 4px 0
      .phone-icon
        font-size: 16px
        vertical-align: middle
        animation: call 1.8s ease-in-out infinite
        animation-delay: 2s
  .footer__btn
    border: 0
    background-color: transparent
    border-radius: 0
    background-repeat: no-repeat
    background-image: url(../../public/images/arrow-btn.svg)
    padding: 0
    width: 28px
    height: 28px
    position: absolute
    top: 50%
    -webkit-transform: translateY(-50%)
    transform: translateY(-50%)
    right: 10px
    &:hover
      cursor: pointer
  .main-nav
    background-color: #fff
    width: 100%
    transition: all 0.3s
    padding-top: 0
    max-height: 0
    overflow: hidden
    will-change: auto
    &.is-active
      overflow: visible
      padding-top: 35px
      max-height: 500px
    .container
      max-width: 1200px
  .main-nav__wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: justify
    justify-content: space-between
    -ms-flex-align: start
    align-items: flex-start
  .main-nav__col
    width: auto
    padding-right: 25px
  .main-nav__title
    font-size: 24px
    font-weight: 600
    margin-top: 0
    margin-bottom: 24px
    color: #000
  .main-nav__link
    font-size: 14px
    display: table
    font-weight: 500
    margin-bottom: 15px
    &:last-child
      margin-bottom: 0
  .promo
    padding-top: 90px
  .promo__wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: justify
    justify-content: space-between
    -ms-flex-align: stretch
    align-items: stretch
  .promo__info
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-direction: column
    flex-direction: column
    -ms-flex-pack: justify
    justify-content: space-between
    padding: 55px 75px 65px 0
    width: 58%
  .promo__logo
    width: 100%
    display: block
    max-width: 480px
    margin-left: auto
    margin-bottom: 50px
  .promo__try
    width: 100%
    max-width: 480px
    margin-left: auto
    margin-top: auto
  .promo__image-wrap
    width: 42%
    img
      display: block
      width: 100%
      min-height: 100%
      height: auto
      -o-object-fit: cover
      object-fit: cover
  .promo__text
    margin-top: 0
    margin-bottom: 24px
    font-size: 16px
    line-height: 24px
    color: #4D4D4D
    max-width: 380px
  .promo__btn
    display: inline-block
    text-align: center
    text-transform: uppercase
    font-weight: 400
    font-size: 16px
    padding: 24px 36px
    color: #fff
    margin-bottom: 8px
    background-color: #363636
  .promo__hint
    font-size: 14px
    opacity: 0.5
    margin: 0
    color: #4D4D4D
  .common-section
    padding: 135px 0
  .common-section__title
    margin-top: 0
    margin-bottom: 30px
    padding-bottom: 25px
    position: relative
    font-size: 36px
    font-weight: 700
    color: #000
    display: table
    &:before
      content: ''
      position: absolute
      bottom: 0
      right: 0
      height: 12px
      background-color: #000
      width: calc(100% + 30px)
  .common-block
    width: 50%
    max-width: 250px
    min-height: 250px
    padding: 24px
    position: relative
    background-color: #4D4D4D
    &.slider
      width: auto
      max-width: unset
    &:hover
      cursor: pointer
  .common-block.is-active .common-block__number, .common-block.slick-current .common-block__number
    opacity: 1
  .common-block.is-active .common-block__bottom, .common-block.slick-current .common-block__bottom
    opacity: 1
  .common-block--empty
    background-color: transparent
    &:before
      content: ''
      position: absolute
      top: 50%
      -webkit-transform: translateY(-50%)
      transform: translateY(-50%)
      right: 0
      width: 180px
      background-color: #000
      height: 16px
  .common-block--grey
    background-color: #363636
  .common-block--grey.is-active, .common-block--grey.slick-current
    box-shadow: 0 0 5px #363636
  .common-block--green
    background-color: #68826F
  .common-block--green.is-active, .common-block--green.slick-current
    box-shadow: 0 0 5px #68826F
  .common-block--dgreen
    background-color: #4D6252
  .common-block--dgreen.is-active, .common-block--dgreen.slick-current
    box-shadow: 0 0 5px #4D6252
  .common-block--red
    background-color: #825B5B
  .common-block--red.is-active, .common-block--red.slick-current
    box-shadow: 0 0 5px #825B5B
  .common-block--blue
    background-color: #5B7082
  .common-block--blue.is-active, .common-block--blue.slick-current
    box-shadow: 0 0 5px #5B7082
  .common-block__title
    font-size: 24px
    font-weight: 700
    margin: 0
    color: #fff
    .top
      font-size: 16px
      font-weight: 700
      text-transform: uppercase
      position: relative
      padding-right: 18px
      color: #363636
      vertical-align: super
      white-space: nowrap
      &:after
        content: ''
        position: absolute
        top: 50%
        -webkit-transform: translateY(-50%)
        transform: translateY(-50%)
        right: 0
        width: 15px
        height: 15px
        background-repeat: no-repeat
        background-size: 100%
        background-image: url(../../public/images/star.svg)
    .soon
      display: block
      font-size: 16px
      text-transform: lowercase
      font-weight: 700
      color: #363636
  .common-block__number
    color: #fff
    font-size: 144px
    font-weight: 700
    position: absolute
    right: 10px
    bottom: -50px
    opacity: 0.2
    transition: all 0.3s
  .common-block__bottom
    position: absolute
    right: 15px
    bottom: 15px
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: end
    justify-content: flex-end
    -ms-flex-align: center
    align-items: center
    opacity: 0.2
    transition: all 0.3s
  .common-block__bottom--text
    -ms-flex-direction: column
    flex-direction: column
    padding: 16px
    border-radius: 8px
    max-width: 180px
    background-color: #fff
    -ms-flex-align: start
    align-items: flex-start
  .common-block__text-item
    font-size: 12px
    font-weight: 400
    margin-top: 0
    margin-bottom: 8px
    color: #68826F
    &:last-child
      margin-bottom: 0
  .common-block__icon
    width: 48px
    height: 48px
    display: inline-block
    margin-left: 8px
  .about__wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: justify
    justify-content: space-between
    -ms-flex-align: start
    align-items: flex-start
  .about__info-wrapper
    width: 58%
  .about__blocks-wrapper
    width: 42%
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: start
    justify-content: flex-start
    -ms-flex-align: stretch
    align-items: stretch
    -ms-flex-wrap: wrap
    flex-wrap: wrap
  .about__mobile-info
    display: none
  .about__subtitle
    margin-top: 50px
    margin-bottom: 24px
    font-size: 24px
    font-weight: 700
    text-transform: uppercase
    color: #4D4D4D
    max-width: 350px
    margin-left: auto
    margin-right: auto
    width: 100%
  .about__text
    font-size: 16px
    line-height: 24px
    margin: 0
    color: #4D4D4D
    max-width: 350px
    margin-left: auto
    margin-right: auto
    width: 100%
  .about__tabs-wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: justify
    justify-content: space-between
    -ms-flex-align: start
    align-items: flex-start
  .about__tab-item
    width: 50%
    padding-left: 25px
    margin: 0
    font-size: 16px
    line-height: 24px
    color: #4D4D4D
    position: relative
  .about__tabs
    width: 50%
    max-height: 520px
    overflow-y: auto
    padding-right: 25px
    &::-webkit-scrollbar-track
      width: 2px
      box-shadow: none
      background-color: transparent
    &::-webkit-scrollbar
      width: 2px
      box-shadow: none
      background-color: transparent
    &::-webkit-scrollbar-thumb
      width: 2px
      background-color: #ECECEC
      border-radius: 2px
  .about__tab-link
    display: block
    margin-bottom: 25px
    padding: 24px
    padding-left: 80px
    position: relative
    text-transform: uppercase
    font-size: 16px
    font-weight: 700
    transition: all 0.3s
    &:last-child
      margin-bottom: 0
    img
      position: absolute
      top: 50%
      -webkit-transform: translateY(-50%)
      transform: translateY(-50%)
      left: 35px
      width: 25px
      height: 25px
  .about__tab-link:hover, .about__tab-link.is-active
    background-color: #ECECEC
  .rates
    padding-bottom: 50px
  .rates__wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: justify
    justify-content: space-between
    -ms-flex-align: start
    align-items: flex-start
  .rates__blocks-wrapper
    width: 42%
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: start
    justify-content: flex-start
    -ms-flex-align: stretch
    align-items: stretch
    -ms-flex-wrap: wrap
    flex-wrap: wrap
    padding-top: 100px
  .rates__info-wrapper
    width: 42%
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-direction: column
    flex-direction: column
  .rates__subtitle
    margin-top: 0
    font-size: 24px
    margin-bottom: 48px
    font-weight: 700
    color: #000
  .rates__list
    margin: 0
    padding: 0
    margin-bottom: 140px
  .rates__list-item
    display: list-item
    margin-bottom: 24px
    font-size: 16px
    font-weight: 700
    color: #4D4D4D
    padding-left: 40px
    position: relative
    &:before
      content: ''
      position: absolute
      top: -1px
      left: 0
      width: 20px
      height: 20px
      background-color: #363636
  .rates__price
    font-size: 28px
    margin: 24px 0
    font-weight: 700
    text-transform: uppercase
  .rates__btn
    display: table
    font-size: 16px
    text-transform: uppercase
    font-weight: 700
    text-align: center
    color: #fff
    padding: 24px 48px
    background-color: #363636
  .products__wrap
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: justify
    justify-content: space-between
    -ms-flex-align: stretch
    align-items: stretch
  .products__info-wrapper
    width: 58%
  .products__blocks-wrapper
    width: 42%
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-pack: start
    justify-content: flex-start
    -ms-flex-align: stretch
    align-items: stretch
    -ms-flex-wrap: wrap
    flex-wrap: wrap
  .products__subtitle
    margin-top: 50px
    margin-bottom: 24px
    font-size: 24px
    font-weight: 700
    text-transform: uppercase
    color: #4D4D4D
    max-width: 315px
    margin-left: auto
    margin-right: auto
    width: 100%
  .products__text
    font-size: 16px
    line-height: 24px
    margin: 0
    color: #4D4D4D
    max-width: 315px
    margin-left: auto
    margin-right: auto
    width: 100%
    margin-bottom: 20px
  .products__slider
    height: 100%
  .products__slide
    display: -ms-flex
    display: -ms-flexbox
    display: flex
    -ms-flex-direction: column
    flex-direction: column
    min-height: 100%
  .products__btn
    display: table
    font-size: 16px
    text-transform: uppercase
    font-weight: 700
    color: #fff
    padding: 24px 48px
    background-color: #363636
    max-width: 315px
    width: 100%
    text-align: center
    margin-top: auto
    margin-left: auto
    margin-right: auto
  .text-page
    padding-top: 150px
    padding-bottom: 50px
    .container
      max-width: 1060px
  .text-page__title
    margin-top: 0
    font-weight: 700
    margin-bottom: 35px
    font-size: 32px
  .text-page__text
    font-size: 16px
    line-height: 24px
    margin-top: 0
    margin-bottom: 10px
    a
      color: #15c
      &:hover
        text-decoration: underline
  .text-page__subtitle
    font-size: 24px
    font-weight: 700
    margin-top: 30px
    margin-bottom: 15px
  .text-page__list-ol, .text-page__list-ul
    margin: 30px 0
    padding-left: 35px
  .text-page__list-ol a, .text-page__list-ul a
    color: #15c
  .text-page__list-ol a:hover, .text-page__list-ul a:hover
    text-decoration: underline
  .text-page__list-ol li, .text-page__list-ul li
    font-size: 16px
    margin-top: 0
    margin-bottom: 10px
    display: list-item
  .text-page__list-ul
    li
      list-style-type: disc


  @media only screen and (max-width: 1336px)
    .common-block
      min-height: 225px
    .common-block__title
      font-size: 20px
    .main-nav__title
      font-size: 20px
      white-space: nowrap



  @media only screen and (max-width: 992px)
    .container
      padding-left: 20px
      padding-right: 20px
    .common-section
      padding: 75px 0
    .promo__btn
      padding: 20px 30px
    .about
      padding-bottom: 25px
    .about__wrap
      -ms-flex-direction: column-reverse
      flex-direction: column-reverse
    .about__blocks-wrapper
      width: 100%
      margin-bottom: 60px
      .common-block
        max-width: 235px
      .common-block--empty
        display: none
    .about__info-wrapper
      width: 100%
    .about__subtitle
      margin-top: 0
    .about__tab-link
      margin-bottom: 10px
    .rates
      padding-bottom: 25px
    .rates__wrap
      -ms-flex-direction: column
      flex-direction: column
    .rates__info-wrapper
      width: 100%
    .rates__blocks-wrapper
      padding-top: 0
      width: 100%
      -ms-flex-wrap: nowrap
      flex-wrap: nowrap
      overflow-x: auto
      margin-bottom: 25px
      &::-webkit-scrollbar
        display: none
        width: 0
        background-color: transparent
        height: 0
      .common-block
        max-width: 235px
        min-width: 235px
    .rates__list
      margin-bottom: 0
    .rates__bottom
      display: -ms-flex
      display: -ms-flexbox
      display: flex
      -ms-flex-direction: row-reverse
      flex-direction: row-reverse
      width: 100%
      -ms-flex-align: center
      align-items: center
      -ms-flex-pack: end
      justify-content: flex-end
    .rates__price
      margin: 0
      margin-left: 15px
    .products
      padding-bottom: 25px
    .products__wrap
      -ms-flex-direction: column
      flex-direction: column
    .products__blocks-wrapper
      width: 100%
      .common-block
        max-width: 235px
      .common-block--empty
        display: none
    .products__info-wrapper
      width: 100%
      margin-bottom: 65px
    .footer
      padding: 50px 0
    .footer__wrap
      -ms-flex-wrap: wrap
      flex-wrap: wrap
    .footer__col
      width: 50%
      margin-bottom: 35px
    .footer__contacts
      width: 100%
      margin-top: 35px
      padding-bottom: 100px
    .footer__logo
      margin-left: auto
      margin-right: auto
      margin-bottom: 28px
    .footer__form
      margin-left: auto
      margin-right: auto
      padding-bottom: 0
      &:after
        display: none

  @media only screen and (max-width: 767px)
    .common-section
      padding: 25px 0
    .common-section__title
      font-size: 24px
      padding-bottom: 10px
      margin-bottom: 25px
      &:before
        height: 4px
    .common-block:not(.slider)
      margin-right: 15px
    .promo
      padding-bottom: 25px
    .promo__wrap
      -ms-flex-direction: column-reverse
      flex-direction: column-reverse
    .promo__image-wrap
      width: 100%
      margin-bottom: 25px
    .promo__info
      padding: 0
      width: 100%
    .promo__logo
      display: none
    .promo__text
      text-align: center
      font-weight: 600
    .promo__btn
      display: table
      padding: 16px
      font-size: 12px
      margin-left: auto
      margin-right: auto
    .promo__hint
      text-align: center
      font-size: 12px
    .about
      .common-section__title
        margin-bottom: 55px
      .common-block
        max-width: 250px
        min-height: 250px
        min-width: 170px
    .about__mobile-info
      display: block
    .about__tabs-wrap
      display: none
    .about__subtitle
      font-size: 18px
    .about__text
      font-size: 15px
    .about__blocks-wrapper
      width: calc(100% + 40px)
      margin-left: -20px
      margin-right: -20px
      .slick-list
        padding-left: 20px
    .rates
      .common-block
        min-height: 175px
        min-width: 1px
        padding: 20px
        &.slider
          min-width: 175px
      .common-block__title
        font-size: 16px
        .top
          padding-right: 15px
          &:after
            width: 11px
            height: 11px
      .common-block__number
        font-size: 72px
        bottom: -30px
    .rates .common-block__title .top,
    .rates .common-block__title .soon
      font-size: 12px
    .rates__subtitle
      font-size: 16px
      margin-bottom: 22px
    .rates__list-item
      font-size: 14px
    .rates__btn
      font-size: 12px
      padding: 16px
    .rates__price
      font-size: 16px
      opacity: 0.5
    .rates__blocks-wrapper
      width: calc(100% + 40px)
      margin-left: -20px
      margin-right: -20px
      .slick-list
        padding-left: 20px
    .products
      .common-section__title
        margin-bottom: 65px
      .common-block
        max-width: 250px
        min-height: 250px
    .products__wrap
      -ms-flex-align: start
      align-items: flex-start
    .products__subtitle
      margin-top: 0
    .products__btn
      font-size: 12px
      padding: 16px
      width: auto
      margin-left: 0
      margin-right: 0
    .products__slide
      min-height: 1px
    .products__main-slider
      min-height: 1px
      height: auto
    .products__blocks-wrapper
      width: calc(100% + 40px)
      margin-left: -20px
      margin-right: -20px
      .slick-list
        padding-left: 20px
    .text-page__title
      font-size: 26px
    .text-page__subtitle
      font-size: 20px
    .main-nav
      &.is-active
        max-height: 1000px
    .main-nav__wrap
      -ms-flex-direction: column
      flex-direction: column
    .main-nav__col
      width: 100%
      padding-right: 0
      margin-bottom: 35px
      &:last-child
        margin-bottom: 15px
    .main-nav__title
      font-size: 24px
      margin-bottom: 0px
      position: relative
      padding-right: 20px
      &:after
        content: ''
        position: absolute
        top: 50%
        -webkit-transform: translateY(-50%)
        transform: translateY(-50%)
        right: 0
        width: 20px
        height: 20px
        background-repeat: no-repeat
        background-size: 100%
        background-image: url(../../public/images/arrow-left.png)
        transition: all 0.3s
      &.is-active
        &:after
          -webkit-transform: translateY(-50%) rotate(-90deg)
          transform: translateY(-50%) rotate(-90deg)
        & + .main-nav__list
          overflow: visible
          max-height: 500px
          padding-top: 25px
    .main-nav__list
      padding-top: 0
      overflow: hidden
      max-height: 0
      transition: all 0.25s ease
      will-change: auto
    .footer
      padding: 25px 0
    .footer__contacts
      margin-top: 0
      padding-bottom: 100px
    .footer__title
      font-size: 16px
      margin-bottom: 24px
    .footer__link
      font-size: 12px
      margin-bottom: 24px
    .footer__form-title
      text-align: center
      font-size: 16px
    .header
      padding: 15px 0
      top: 8px
      left: 8px
      width: calc(100% - 16px)
    .header__link
      display: none
    .main-nav__mobile
      display: block
      font-weight: 600
      color: #444
    .header__wrap
      align-items: center
      justify-content: space-between
    .header__logo
      margin: 0
      img
        margin-bottom: 20px
    .header__menu
      margin-left: 0
    .footer__phone-block
      display: none
  @media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)
    .icon-logo
      background-size: 300px 70px


  @keyframes call
    0%
      transform: rotate(9deg)
    70%
      transform: rotate(-10deg)
    80%
      transform: rotate(0deg)
    100%
      transform: rotate(8deg)
</style>
